import { createSelector } from '@reduxjs/toolkit'
import { siteLicenseChecker } from 'lib/util'
import { getSitesWithAdminClaim } from 'utils/accessHelpers'
import sitesSelectors from 'store/sitesManager/selectors'

const selectSites = state => state.sitesManager.sites.data

export const selectUserManagementBaseState = state => {
  const {
    licenseManager,
    router,
    sitesManager: {
      sites: { isLoading: isSitesLoading },
      siteUsers: {
        addBulkUsersResponse,
        isLoading: isSiteUsersLoading,
        isUpdating,
        isAddBulkUsersCompleted,
      },
      remindUsers: { isLoading: isSending },
    },
  } = state

  return {
    addBulkUsersResponse,
    hasUnassignedLicenses:
      licenseManager?.userLicenses?.unassignedLicenses?.length > 0,
    isAddBulkUsersCompleted,
    isLoading: isSitesLoading || isSiteUsersLoading || isSending,
    isUpdating,
    location: router.location,
  }
}

export const selectAdminSites = createSelector(
  [selectSites],
  getSitesWithAdminClaim,
)

export const selectSiteForUserManagement = (adminSites, siteId) =>
  !siteId ? adminSites?.[0] : adminSites?.find(site => site.id === siteId)

export const selectSiteUsersForUserManagement = (state, siteId, site) => {
  if (!site || !siteId) return null

  const { hasK8License } = siteLicenseChecker(site)
  return sitesSelectors.selectSiteUsersBySiteId(state, siteId, hasK8License)
}
